export default __webpack_public_path__ + "76985f3fcc460ede8a4a74d0ff27cc43944157820b1014180e9789bf1465f92d.svg";